import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Autocomplete, Box, Paper, TextField } from "@mui/material";
import type { PurchaseOrder } from "../models/RollsReceived";

interface Props {
	purchaseOrders: PurchaseOrder[];
	selectedPO: PurchaseOrder | null;
	loading: boolean;
	onSelect: (po: PurchaseOrder | null) => void;
	onReset: () => void;
	canReset: boolean;
}

const optionLabel = (po: PurchaseOrder): string =>
	po.SupplierName
		? `${po.Number?.trim()} — ${po.SupplierName}`
		: `${po.Number?.trim()}`;

export const RollsReceivedToolbar = ({
	purchaseOrders,
	selectedPO,
	loading,
	onSelect,
	onReset,
	canReset,
}: Props) => {
	return (
		<Paper
			elevation={3}
			sx={{
				px: 1.5,
				py: 0.75,
				mb: 1,
				display: "flex",
				gap: 1,
				alignItems: "center",
				flexWrap: "wrap",
			}}
		>
			<Autocomplete
				size="small"
				sx={{ minWidth: 360 }}
				options={purchaseOrders}
				value={selectedPO}
				loading={loading}
				getOptionLabel={optionLabel}
				isOptionEqualToValue={(o, v) => o.Id === v.Id}
				onChange={(_e, option) => onSelect(option)}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Purchase Order"
						placeholder="Search by number or supplier"
					/>
				)}
			/>
			<ResetFiltersButton onClick={onReset} disabled={!canReset} />

			<Box sx={{ flex: 1 }} />
		</Paper>
	);
};
